import { color } from '@starryui10/theme/color';
import * as React from 'react';
import styled from 'styled-components';
import { IToggleSwitchStatus } from './ToggleSwitchWithLabel';

export const ToggleSwitch = (props: IToggleSwitchStatus) => {
    return (
        <ToggleSwitchBar {...props}>
            <ToggleSwitchKnob {...props} />
        </ToggleSwitchBar>
    );
};

export const ToggleSwitchBar = styled.span<IToggleSwitchStatus>`
    background: ${(p) => (p.isSelected ? color.Blue.B60 : color.Grey.G40)};
    position: relative;
    display: inline-flex;
    align-items: center;
    width: 48px;
    height: 24px;
    border-radius: 12px;
    border: none;
    box-sizing: border-box;
`;

const ToggleSwitchKnob = styled.span<IToggleSwitchStatus>`
    left: ${(p) => (p.isSelected ? 26 : 2)}px;
    position: absolute;
    width: 20px;
    height: 20px;
    background-color: ${color.StarRezBrandColors.WhiteSR};
    border-radius: 10px;
    transition: left 0.3s;
`;
